export default {
  "ddbe9fdda1937e8067ae26d31e758a69": "確認訂單收銀台",
  "f60e3d2b532a6909bcdd56086693c022": "贈課：",
  "af4e086186dc7292e7fe6d5d4af8e070": "; 贈品：",
  "fe7ef76e50b4b8982b4986961a1e48be": "優惠券ID：",
  "20afd873cfb7cf8e96c084e603feb32b": "; 代金券ID：",
  "3d43a03f9649af819ca1cd07795d175d": "; 合計價格：",
  "64a7c518c73dc80c929280695ef7f730": "該商品暫時無法購買，請聯繫客服",
  "f274c45fe1f59f943b0635650644f18f": "未選擇商品",
  "e5221976fe0061c364b2af35d755b2bd": "未選擇地址",
  "1bc7355c38a9105d09bcc42e6beea46b": "未選擇支付方式",
  "ac14a25586644305c664a0cfd0745924": "未檢測到支付寶",
  "6d29c550cf3e1024a5bb939352a68a30": "確認訂單收銀台-立即支付按鈕點擊",
  "11033d3cd42c64a797ba83c8e1d411c1": "商城訂單確認頁_底部按鈕",
  "3c8e67cdffc4247838f712b776ff133e": "商城訂單確認頁_優惠券點擊",
  "3b8b66af6eacd73cd5646dbced53f092": "已下架",
  "fbd0b805b279b854b092c73047e59a53": "已售罄",
  "c4bb227feaf34e0fb7111d181c92ee48": "立即兑換",
  "813068367ffc4a2607ad35d2907e96d3": "立即簽約",
  "f8b36b90160e00e89d9964d966acb108": "0元簽約",
  "640cc04f9a9212f49be05074a04ccfa0": "立即支付",
  "920338af3975d212bed08b7e45cc8713": "下單頁",
  "37111d7686ec1139e22178f585782461": "擴科組件曝光",
  "1dbe524f32b40d27c74c2426ee899732": "參數錯誤!",
  "1be65297d44b755319cf6ea4a2b9659e": "簽約中...",
  "e5e6097c06fd5f5d3e87ae462adc8f23": "支付中...",
  "2d962569f8d1c75433f8d9fa3d1fa5f6": "商品明細",
  "fc47c520fb3452ac8dcd243e54a8f2e1": "價格明細",
  "1d6f71e5c4c07373595e37b34ded4a11": "支付方式",
  "07710d908fd710218e2f38df3bc99d90": "您確定要放棄支付嗎？",
  "74e152f4159cf367bdbd756936b73a86": "支付結果確認中",
  "9adb2a2ad039b13485a06ffd4ec9f229": "請勿重複支付或離開此頁面哦"
}
